import { render, staticRenderFns } from "./EstablishmentInternalInvoiceListTable.vue?vue&type=template&id=a96704f0"
import script from "./EstablishmentInternalInvoiceListTable.vue?vue&type=script&lang=js"
export * from "./EstablishmentInternalInvoiceListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports